import {
  StyledDirectionalityLabel,
  StyledDirectionalityLegendMarker,
  StyledDirectionalityLegend,
} from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/ContributionByCampaigns.style';
import {
  useBrandAffinityTranslation,
  BRAND_AFFINITY_NAMES_TO_I18N_KEYS,
  BrandAffinityLevel,
} from 'modules/domains/brandAffinity';
import {
  IMPROVED_TO,
  DEGRADED_TO,
} from 'modules/intelligentInsights/brandAffinityInsights/constants';
import { Direction, DirectionEnum } from 'modules/intelligentInsights/brandAffinityInsights/types';

export type DirectionalityLegendType = {
  cohort: BrandAffinityLevel;
  directionality: Direction;
};
export const DirectionalityLegend = ({ cohort, directionality }: DirectionalityLegendType) => {
  const { t } = useBrandAffinityTranslation();
  const translatedLabel = t(BRAND_AFFINITY_NAMES_TO_I18N_KEYS[cohort]);
  const directionalityText =
    directionality === DirectionEnum.up
      ? `${IMPROVED_TO} ${translatedLabel}`
      : `${DEGRADED_TO} ${translatedLabel}`;
  return (
    <StyledDirectionalityLegend>
      <StyledDirectionalityLegendMarker data-directionality={directionality} />
      <StyledDirectionalityLabel>{directionalityText}</StyledDirectionalityLabel>
    </StyledDirectionalityLegend>
  );
};
